var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10,43.7c0-4.6,3.7-8.4,8.4-8.4h219.2c4.6,0,8.4,3.9,8.4,8.4c0,4.6-3.7,8.4-8.4,8.4H18.4C13.8,52.1,10,48.2,10,43.7L10,43.7z M10,128c0-4.6,3.7-8.4,8.4-8.4h219.2c4.6,0,8.4,3.9,8.4,8.4c0,4.6-3.7,8.4-8.4,8.4H18.4C13.8,136.4,10,132.5,10,128L10,128z M10,212.3c0-4.6,3.7-8.4,8.4-8.4h219.2c4.6,0,8.4,3.9,8.4,8.4c0,4.6-3.7,8.4-8.4,8.4H18.4C13.8,220.7,10,216.8,10,212.3L10,212.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenuIcon);
export default __webpack_public_path__ + "static/media/side-menu-icon.1b5279b46749da1829625756114e2533.svg";
export { ForwardRef as ReactComponent };